<template>
  <div>
    <filter-card :get-report="getReport" />
    <b-card no-body>
      <report-table />
      <b-card-body v-if="loading">
        <pre-loading />
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import { BCard, BCardBody } from 'bootstrap-vue'
import ReportTable from '@/views/Admin/Reports/Banks/components/ReportTable.vue'
import FilterCard from '@/views/Admin/Reports/Banks/components/FilterCard.vue'
import PreLoading from '@/layouts/components/common/PreLoading.vue'

export default {
  name: 'IndexPage',
  components: {
    BCard,
    BCardBody,
    ReportTable,
    FilterCard,
    PreLoading,
  },
  computed: {
    dataList() {
      return this.$store.getters['banksReports/dataList']
    },
    filterParams() {
      return this.$store.getters['banksReports/filterParams']
    },
    loading() {
      return this.$store.getters['banksReports/loading']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('banksReports/getReport', this.filterParams)
    },
  },
}
</script>
